import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { environment } from 'src/app/environments/environments';

@Component({
  selector: 'app-forget-password-dialog',
  templateUrl: './forget-password-dialog.component.html',
  styleUrls: ['./forget-password-dialog.component.scss'],
})
export class ForgetPasswordDialogComponent implements OnInit {
  isFetching = false;
  isMobileExists = false;
  isChecking = false;
  isChecked = false;
  isRequested = false;
  isError = false;
  screenSize: ScreenType;
  baseServerURL = environment.apiUrl;
  organizations: IOrganization[];
  constructor(
    private httpclient: HttpClient,
    private formbuilder: FormBuilder,
    private _screenSize: AumyeResponsiveScreenService
  ) {
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  forgetPasswordForm = this.formbuilder.group({
    orgId: [''],
    mobileNumber: ['', Validators.required],
  });
  ngOnInit(): void {}
  onCheckMobileNumberExists() {
    this.isFetching = true;
    this.isMobileExists = false;
    this.isChecking = true;
    const data = {
      mobile: this.forgetPasswordForm.controls.mobileNumber.value,
    };
    const params = new HttpParams().set('data', JSON.stringify(data));

    const baseServerURL = this.baseServerURL + 'GetAllOrganization';

    this.httpclient.get(baseServerURL, { params }).subscribe({
      next: (res: any) => {
        this.organizations = res;
        this.isFetching = false;
        this.isChecking = false;
        this.isChecked = true;
        this.isMobileExists = true;
      },
      error: (err) => {
        console.error('Error fetching organizations', err);
        this.isFetching = false;
        this.isChecking = false;
        this.isMobileExists = false;
      },
    });
  }

  onCheckUserExists() {
    this.isFetching = true;
    this.isChecking = true;
    this.isChecked = true;
    const httpOptions = {
      headers: new HttpHeaders({
        OrganizationID: this.forgetPasswordForm.controls.orgId.value,
      }),
    };
    let baseServerURL = this.baseServerURL + 'CheckExistingUser';
    try {
      this.httpclient
        .post(baseServerURL, this.forgetPasswordForm.value, {
          headers: httpOptions.headers,
          responseType: 'text',
        })
        .subscribe(
          (res: any) => {
            this.isMobileExists = false;
            this.isChecking = false;
            this.isFetching = false;
          },
          (err) => {
            if (err.error === 'Email or Mobile already exists and active') {
              this.isMobileExists = true;
              this.isChecking = false;
              this.isFetching = false;
            }
          }
        );
    } catch (e) {
      console.log(e);
    }
  }
  onRequestNewCreds() {
    this.isChecking = true;
    let baseServerURL = this.baseServerURL + 'RequestCredential';
    this.httpclient
      .post(baseServerURL, this.forgetPasswordForm.value, {
        responseType: 'text',
      })
      .subscribe(
        (res: any) => {
          this.isRequested = true;
          this.isChecking = false;
        },
        (err) => {
          this.isError = true;
          this.isChecking = false;
        }
      );
  }
  ScreenType = ScreenType;
}

export interface IOrganization {
  organizationID: string;
  organizationName: string;
}
